module.exports = __webpack_public_path__ + "img/userEquity1.98116c49.png";